import React, { useRef, useState, Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { ModalBody, ModalContent, TabbedPanel, TabHeading, TabContent } from './styled';
import Doughnuts from '../../components/doughnuts/doughnuts';
import TopProblemQuestions from '../../components/top-problem-questions/top-problem-questions';
import AssignLearningJourneys from '../../components/assign-learning-journeys/assign-learning-journeys';
import LearningGapsModalHeader from '../../components/learning-gaps-modal/learning-gaps-modal-header';
import LearningGapsModalFilters from '../../components/learning-gaps-modal/learning-gaps-modal-filters';
import SvgIcon from '../../components/svg-icon/svg-icon';
import { ClassIcon, StudentIcon } from '../../helpers/icon-dictionary';
import LearningGapsModalFooter from '../../components/learning-gaps-modal/learning-gaps-modal-footer';
import StudentLearningGaps from '../../components/student-learning-gaps/student-learning-gaps';
import { pausePolling, resumePolling } from '../upf-assign/upf-assign-actions';
import { clearLearningGaps } from './link-upf-modal-actions';

const LinkUpfModal = ({ i18n, groupSelection }) => {
  const modalRef = useRef(null);
  const dispatch = useDispatch();
  const questions = useSelector(state => state.linkUpfModalReducer.questions);
  const isLoading = useSelector(state => state.linkUpfModalReducer.isLoading);
  const resultType = useSelector(state => state.linkUpfModalReducer.resultType);
  const classroomPct = useSelector(state => state.linkUpfModalReducer.classroomPct);
  const groupPct = useSelector(state => state.linkUpfModalReducer.groupPct);
  const studentProfileIds = useSelector(state => state.linkUpfModalReducer.studentProfileIds);
  const students = useSelector(state => state.linkUpfModalReducer.students);

  const noQuestions = !(questions && questions.length);

  const [selectedGroup, setSelectedGroup] = useState(groupSelection);
  const TABS = {
    GROUPS: 'GROUPS',
    STUDENTS: 'STUDENTS'
  };
  const [activeTab, setActiveTab] = useState(TABS.GROUPS);

  const onGroupChange = (option) => {
    setSelectedGroup(option);
  };

  useEffect(() => {
    dispatch(pausePolling());

    return () => {
      dispatch(clearLearningGaps());
      dispatch(resumePolling());
    };
  }, []);

  return (
    <ModalBody ref={modalRef}>
      <LearningGapsModalHeader i18n={i18n} />
      <ModalContent>
        <TabbedPanel>
          <TabHeading
            disabled={isLoading}
            selected={activeTab === TABS.GROUPS}
            onClick={() => { setActiveTab(TABS.GROUPS); }}
          >
            <SvgIcon icon={ClassIcon} />{i18n.t`Groups`}
          </TabHeading>
          <TabHeading
            disabled={isLoading}
            selected={activeTab === TABS.STUDENTS}
            onClick={() => { setActiveTab(TABS.STUDENTS); }}
          >
            <SvgIcon icon={StudentIcon} />{i18n.t`Students`}
          </TabHeading>
          <TabContent>
            <LearningGapsModalFilters
              i18n={i18n}
              groupSelection={selectedGroup}
              onGroupChange={onGroupChange}
              isGroupData={activeTab === TABS.GROUPS}
            />
            <hr />
            {!isLoading && activeTab === TABS.GROUPS && (
              <Fragment>
                <div className="doughnuts-questions-block">
                  <Doughnuts i18n={i18n} data={{ resultType, groupPct, classroomPct, noQuestions }} />
                  <TopProblemQuestions i18n={i18n} />
                </div>
                <AssignLearningJourneys
                  i18n={i18n}
                  data={{
                    groupSelection: selectedGroup,
                    questions,
                    studentProfileIds
                  }}
                />
              </Fragment>
            )}
            {activeTab === TABS.STUDENTS && students &&
              students.map(student => (
                <StudentLearningGaps
                  key={student.id}
                  student={student}
                  i18n={i18n}
                />
              ))
            }
          </TabContent>
        </TabbedPanel>
      </ModalContent>
      <LearningGapsModalFooter i18n={i18n} showAssignAll={activeTab === TABS.STUDENTS} />
    </ModalBody>
  );
};

LinkUpfModal.propTypes = {
  i18n: PropTypes.object,
  groupSelection: PropTypes.object
};

const createLinkUpfModal = (i18n, groupSelection) => ({
  content: <LinkUpfModal i18n={i18n} groupSelection={groupSelection} />,
  id: 0,
  className: 'linkUpfModalStyle',
  buttons: []
});

export default createLinkUpfModal;
